export const headerHeightPx = '80px';
export const mobileHeaderHeight = 64;
export const mobileHeaderHeightPx = '64px';
export const mobileHeaderNotificationHeightPx = '56px';
export const cguInsurance = 'Insurance by CGU';
